const _ = require('lodash')

$.registerPlugin = function (Plugin, pluginName) {
  pluginName = pluginName || Plugin.prototype.name
  // add the plugin function as a jQuery plugin
  $.fn[pluginName] = function (options) {

    const args = $.makeArray(arguments)
    const rest = args.slice(1)

    return this.each(function () {

      const instance = $.data(this, pluginName)
      if (instance) {
        // call a method on the instance
        if (_.isString(options)) {
          instance[options].apply(instance, rest)
          if (options === 'destroy') {
            $.removeData(this, pluginName)
          }
        } else if (instance.update) {
          instance.update.apply(instance, args)
        }
      } else if (options !== 'destroy') {
        // create a new instance of the plugin
        $.data(this, pluginName, new Plugin(this, options))
      }

    })
  }
}
